import request from "_private/utils/request";
// 进出区域分析导出

// 列表分页查询接口
export function FetchFindByPage(data) {
  return request({
    headers: { type: "json" },
    url: "/report/ExportInOutAreaTask/findByPage",
    method: "post",
    data
  });
}

// 下载文件
export function FileDownload(params) {
  return request({
    url: "/report/ExportDataTask/download",
    method: "get",
    params
  });
}

// 获取任务id
export function getTaskNo() {
  return request({
    url: "/report/ExportInOutAreaTask/getTaskNo",
    method: "post"
  });
}

// 获取车辆树
export function getVehicleInfoTree() {
  return request({
    url: "/base/vehicle/getVehicleInfoTree",
    method: "post"
  });
}

// 获取区域树接口
export function getAreaDataTree() {
  return request({
    url: "/report/ExportInOutAreaTask/getAreaDataTree",
    method: "post"
  });
}

// 保存提交
export function saveExportInOutAreaTask(data) {
  return request({
    headers: { type: "json" },
    url: "/report/ExportInOutAreaTask/saveExportInOutAreaTask",
    method: "post",
    data
  });
}
